module.exports = __webpack_public_path__ + "img/ie-flag.2d1576bd.png";